// Access the strings used on the components.
export const t_help = {
  nextButton: "help.nextButton",
  backButton: "help.backButton",
  defaultSelect: "help.defaultSelect",
  showPasswordCheck: "help.showPasswordCheck",
  timeForNewCodeText: "help.timeForNewCodeText",
  timeForNewCodeLink: "help.timeForNewCodeLink",
  timeForNewCodeCountdown: "help.timeForNewCodeCountdown",
  check: "help.check",
  fieldOrSelect: "help.fieldOrSelect",
  requiredField: "help.requiredField",
  recaptchaWaiting: "help.recaptchaWaiting",
  clientLogoAlt: "help.clientLogoAlt",
  k4dLogoAlt: "help.k4dLogoAlt",
  housienLogoAlt: "help.housienLogoAlt",
  closeAriaLabel: "help.closeAriaLabel",
  toggleTheme: "help.toggleTheme",
};
